document.addEventListener("DOMContentLoaded", () => {
  const foodButtons = document.querySelectorAll(".food-option");
  const foodCount = document.getElementById("foodCount");
  const supplementDiv = document.getElementById("supplementChoice");
  const amino = document.getElementById("amino");
  const aero = document.getElementById("aero");

  [amino, aero, document.getElementById("goal"), document.getElementById("gender"),
   document.getElementById("height"), document.getElementById("weight")]
   .forEach(el => el?.addEventListener("input", updateResults));

  foodButtons.forEach(btn => {
    btn.addEventListener("click", () => {
      btn.classList.toggle("selected");
      const selected = document.querySelectorAll(".food-option.selected");
      if (selected.length > 6) {
        btn.classList.remove("selected");
        alert("Maximal 6 Eiweißquellen auswählbar.");
      }
      const count = selected.length;
      foodCount.textContent = `${count} von 6 Eiweißquellen ausgewählt`;
      supplementDiv.classList.remove("hidden");
      updateResults();
    });
  });

  function updateResults() {
    const gender = document.getElementById("gender").value;
    const height = parseFloat(document.getElementById("height").value);
    const weight = parseFloat(document.getElementById("weight").value);
    const goalFactor = parseFloat(document.getElementById("goal").value);
    const selected = [...document.querySelectorAll(".food-option.selected")].map(b => b.dataset.food);
    const useAmino = amino.checked;
    const useAero = aero.checked;

    if (!height || !weight || (!selected.length && !useAmino && !useAero)) {
      document.getElementById("result").classList.add("hidden");
      return;
    }

    // Idealgewicht / AjBW
    const inches = height / 2.54;
    const over5ft = Math.max(0, inches - 60);
    const ibw = gender === "male" ? 50 + 2.3 * over5ft
              : gender === "female" ? 45.5 + 2.3 * over5ft
              : 47.75 + 2.3 * over5ft;

    let ajbw = weight;
    let weightTypeExplanation = "";

    if (weight <= ibw * 1.05) {
      // Normalgewicht
      weightTypeExplanation = `Da dein Gewicht im normalen Bereich liegt, wurde dein aktuelles Gewicht (${weight.toFixed(1)} kg) für die Berechnung verwendet.`;
    } else {
      // Übergewicht → AjBW verwenden
      ajbw = ibw + 0.4 * (weight - ibw);
      weightTypeExplanation = `Dein angepasstes Körpergewicht (AjBW): <strong>${ajbw.toFixed(1)} kg</strong><br>
      Da dein Gewicht über dem Idealgewicht liegt, wurde das Adjusted Body Weight (AjBW) für die Berechnung verwendet.`;
    }

    const proteinNeed = Math.round(ajbw * goalFactor);

    // Lebensmittel-Daten
    const foods = {
      "Linsen (trocken)": { emoji: "🥣", protein: 25, factor: 2.7 },
      "Kichererbsen (trocken)": { emoji: "🫘", protein: 19, factor: 2.7 },
      "Bohnen (trocken)": { emoji: "🍛", protein: 22, factor: 2.7 },
      "Tofu": { emoji: "🌱", protein: 15 },
      "Fisch": { emoji: "🐟", protein: 22 },
      "Hähnchenbrust": { emoji: "🍗", protein: 23 },
      "Putenbrust": { emoji: "🦃", protein: 24 },
      "Rindfleisch": { emoji: "🥩", protein: 26 },
      "Ei (Hühnerei)": { emoji: "🥚", protein: 7, isEgg: true },
      "Magerquark": { emoji: "🧀", protein: 12 },
      "Quark (20 %)": { emoji: "🍶", protein: 11 },
      "Joghurt 3,5 %": { emoji: "🥛", protein: 3.5 },
      "Hüttenkäse": { emoji: "🧈", protein: 12 },
      "Mandeln": { emoji: "🌰", protein: 21 },
      "Sonnenblumenkerne": { emoji: "🌻", protein: 21 },
      "Erdnussmus": { emoji: "🥜", protein: 25 }
    };

    // Prozentverteilung 60/20/20
    let foodShare = 1.0, aminoShare = 0, aeroShare = 0;
    if (!selected.length && useAmino && !useAero) { aminoShare = 1.0; foodShare = 0; }
    else if (!selected.length && !useAmino && useAero) { aeroShare = 1.0; foodShare = 0; }
    else if (!selected.length && useAmino && useAero) { aminoShare = 0.5; aeroShare = 0.5; foodShare = 0; }
    else if (selected.length && useAmino && !useAero) { aminoShare = 0.2; foodShare = 0.8; }
    else if (selected.length && !useAmino && useAero) { aeroShare = 0.4; foodShare = 0.6; }
    else if (selected.length && useAmino && useAero) { aminoShare = 0.2; aeroShare = 0.2; foodShare = 0.6; }

    const foodProtein = proteinNeed * foodShare;
    const aminoProtein = proteinNeed * aminoShare;
    const aeroProtein = proteinNeed * aeroShare;
    const share = selected.length ? foodProtein / selected.length : 0;

    // Ausgabe
    let html = `<h3>Dein Ergebnis</h3>
      <p><strong>Gesamtbedarf: ${proteinNeed} g Eiweiß</strong><br>
      Davon ${Math.round(foodProtein)} g aus Lebensmitteln
      ${aminoProtein ? `, ${Math.round(aminoProtein)} g aus AminoElements` : ""}
      ${aeroProtein ? `, ${Math.round(aeroProtein)} g aus AeroElements` : ""}.
      </p>
      <p style="font-size:0.95rem;color:#334155;margin-top:0.6rem;">${weightTypeExplanation}</p>
      <p class="protein-label" style="font-size:1rem;font-weight:600;color:#1e3a8a;margin-top:0.6rem;">
      ${foodShare>0?`${Math.round(foodShare*100)} % Lebensmittel`:""}
      ${aminoShare>0?`${foodShare>0?" / ":""}${Math.round(aminoShare*100)} % AminoElements`:""}
      ${aeroShare>0?`${foodShare>0||aminoShare>0?" / ":""}${Math.round(aeroShare*100)} % AeroElements`:""}
      </p>`;

    // Lebensmittel-Ausgabe
    if (selected.length > 0) {
      html += `<h3>Lebensmittel</h3>`;
      selected.forEach(name => {
        const f = foods[name];
        if (!f) return;
        let line = "";
        if (f.isEgg) {
          const eggs = Math.min(3, Math.max(1, Math.round(share / 7)));
          const totalWeight = eggs * 60;
          line = `${eggs} Stück (≈ ${totalWeight} g)`;
        } else {
          const portionDry = (share / f.protein) * 100;
          const cooked = f.factor ? ` → ${(portionDry * f.factor).toFixed(0)} g gekocht` : "";
          line = `ca. ${portionDry.toFixed(0)} g${cooked}`;
        }
        html += `<div class="food-line">
          <span class="food-emoji">${f.emoji}</span>
          <span class="food-name">${name}</span>
          <span class="food-weight">${line}</span>
        </div>`;
      });
    }

    // Supplements-Ausgabe
    if (aminoShare > 0)
      html += `<h3>AminoElements</h3>
        <div class="food-line">
          <span class="food-emoji">💊</span>
          <span class="food-name">AminoElements</span>
          <span class="food-weight">${Math.round(aminoProtein)} Presslinge (${Math.round(aminoProtein)} g)</span>
        </div>`;

    if (aeroShare > 0)
      html += `<h3>AeroElements</h3>
        <div class="food-line">
          <span class="food-emoji">🥤</span>
          <span class="food-name">AeroElements Pulver</span>
          <span class="food-weight">${((aeroProtein / 76) * 100).toFixed(0)} g Pulver (${Math.round(aeroProtein)} g Protein)</span>
        </div>`;

    document.getElementById("result").classList.remove("hidden");
    document.getElementById("foodExamples").innerHTML = html;
  }
});
